import * as React from 'react';
import * as Services from './Services';
import { ProfileApi } from './API/Profile/ProfileApi';
import { AdminApi } from './API/Admin/AdminApi';
import { axiosConfig } from './axiosConfig'
import { IProfileApi } from './API/Profile/IProfileApi';
import { AgeGroupApi } from './API/AgeGroup/AgeGroupApi';
import { EventTypeApi } from './API/EventType/EventTypeApi';
import { RoomApi } from './API/Room/RoomApi';
import { OrderApi } from './API/Order/OrderApi';

import { EventApi } from './API/Event/EventApi';
import { IAppStore } from '../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { GetProfile } from '../Stores/Profile/Actions';
import { connect } from 'react-redux';
import { InvoiceApi } from './API/Invoice/InvoiceApi';
import { ContactInfoApi } from './API/ContactInfo/ContactInfoApi';
import { EventSchedulesApi } from './API/EventSchedules/EventSchedulesApi';
import { HtmlTextsApi } from './API/HtmlTexts/HtmlTextsApi';
import { PhotoGalleryApi } from './API/PhotoGallery/PhotoGalleryApi';



interface IConfigureServiceProps {
    getProfile: () => void;
}

export const backendUrl = () => {
    var url = "/";
    if (process.env.NODE_ENV !== 'production') {
        url = "https://localhost:7164/";
    }
    return url;
}

export const ConfigureService: React.FunctionComponent<IConfigureServiceProps> = (props) => {

    const [loaded, setLoaded] = React.useState(false)
    
    React.useEffect(() => {
        var url = backendUrl();       
        axiosConfig((e:any) => { });
        Services.ServicesProvider.Register(Services.ProfileApi, new ProfileApi(url));
        Services.ServicesProvider.Register(Services.AdminApi, new AdminApi(url));
        Services.ServicesProvider.Register(Services.AgeGroupApi, new AgeGroupApi(url));
        Services.ServicesProvider.Register(Services.RoomApi, new RoomApi(url));
        Services.ServicesProvider.Register(Services.EventTypeApi, new EventTypeApi(url));
        Services.ServicesProvider.Register(Services.EventApi, new EventApi(url));
        Services.ServicesProvider.Register(Services.OrderApi, new OrderApi(url));
        Services.ServicesProvider.Register(Services.InvoiceApi, new InvoiceApi(url));
        Services.ServicesProvider.Register(Services.ContactInfoApi, new ContactInfoApi(url));
        Services.ServicesProvider.Register(Services.EventSchedulesApi, new EventSchedulesApi(url));
        Services.ServicesProvider.Register(Services.HtmlTextsApi, new HtmlTextsApi(url));
        Services.ServicesProvider.Register(Services.PhotoGalleryApi, new PhotoGalleryApi(url));
        
        props.getProfile();
        setLoaded(true);
    }, []);

    return (
        <React.Fragment>
            {loaded?
                 props.children 
                : null}
        </React.Fragment>
    )

}

const ConfigureServiceToProps = (state: IAppStore) => ({
    profile: state.userProfileStore,
 
});

const ConfigureServiceDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({
    getProfile: () => dispatch(GetProfile()),
});

export default connect(ConfigureServiceToProps, ConfigureServiceDispatchToProps)(ConfigureService);
